export default function Footer() {
  return (
    <footer className="bg-[#F8F9FA] py-12">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <div className="flex items-center gap-2">
            <img 
              src="https://static.readdy.ai/image/88011f2529662ad5fc55de36b29bb3e8/c752df5304cc3a404ffb6f7b9d3de882.png" 
              alt="Brightworks Intel" 
              className="h-6 w-auto"
            />
          </div>
          
          <div className="text-sm text-gray-500">
            © 2025 Brightworks Intel • Built for UK service businesses
          </div>
          
          <div className="flex items-center gap-6">
            <a 
              href="mailto:hello@brightworksintel.co.uk" 
              className="text-sm text-[#1A1F36] hover:underline cursor-pointer"
            >
              hello@brightworksintel.co.uk
            </a>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-[#1A1F36] transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}